import { useContext, useEffect, useRef } from "react"
import { AuthContext } from "../../context/Auth/AuthContext"
import { SocketContext } from "../../context/Socket/SocketContext"
import { useRespostaRapidaStore } from "../../stores/respostaRapidaStore"

const QuickMessageSocketInitializer = () => {
  const { user } = useContext(AuthContext)
  const socketManager = useContext(SocketContext)
  const oHandlerRef = useRef(null)

  useEffect(() => {
    if (!user?.id || !user?.companyId) return

    const nCompanyId = user.companyId
    const oSocket = socketManager.getSocket(nCompanyId)
    const cCanal = `company-${nCompanyId}-quickmessage`
    const mFilas = user.queues?.map((oFila) => oFila.id) || []

    const oHandler = (oData) => {
      useRespostaRapidaStore.getState().eventoSocketAplicar(oData, {
        userId: user.id,
        filas: mFilas,
      })
    }
    oHandlerRef.current = oHandler

    oSocket.on(cCanal, oHandler)

    const oRawSocket = oSocket.io?.socket || oSocket
    const reconectarHandler = () => {
      if (oRawSocket?.recovered === false) {
        useRespostaRapidaStore.getState().invalidarTudo()
      }
    }
    oRawSocket?.on?.("connect", reconectarHandler)

    return () => {
      oSocket.off(cCanal, oHandler)
      oRawSocket?.off?.("connect", reconectarHandler)
    }
  }, [socketManager, user?.id, user?.companyId, user?.queues])

  return null
}

export default QuickMessageSocketInitializer
